/** /verify?token=… — where the confirmation link in the sign-up mail lands
 * (ISTOK_AUTH_VERIFY_URL points here). One request, one sentence, one way on. */
import { Link, useSearch } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useSession } from "../auth/SessionContext";
import { confirmEmail } from "../auth/session";
import { product } from "../product";

export function VerifyEmail() {
  const { t } = useTranslation();
  const { principal } = useSession();
  const { token } = useSearch({ strict: false }) as { token?: string };
  const q = useQuery({ queryKey: ["auth", "verify", token], queryFn: () => confirmEmail(token ?? ""), enabled: !!token, retry: false, staleTime: Infinity });
  const state = !token ? "failed" : q.isPending ? "checking" : q.data ? "done" : "failed";

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-4 px-6 py-10">
      <Link to="/" className="wordmark self-start text-2xl" translate="no">
        {product.name}
      </Link>
      <h1 className="display text-2xl">{t(`verifyEmail.${state}.title`)}</h1>
      <p aria-live="polite" className="text-[color:var(--ink-2)]">
        {t(`verifyEmail.${state}.body`)}
      </p>
      {state !== "checking" && (
        <Link to={principal ? "/t" : "/signin"} className="inline-flex min-h-[var(--control-h)] items-center font-medium underline underline-offset-4 hover:decoration-2">
          {principal ? t("teacher.courses") : t("signin.cta")}
        </Link>
      )}
    </main>
  );
}
